import ApiService from './ApiService';

export default class CouponApi extends ApiService {
    constructor() {
        super('system');
    }

    deleteCampain(id) {
        return this.delete(`campain/${id}`);
    }

    updateCampain(payload) {
        const { id, ...rest } = payload;
        return this.put(`campain/${id}`, rest);
    }

    createCampain(payload) {
        return this.post('campain', payload);
    }

    getCampainDetail(id) {
        return this.get(`campain/${id}`);
    }

    createCoupons(payload) {
        return this.post('coupon', payload);
    }

    getCouponList(payload) {
        const { id, ...rest } = payload;
        return this.get(`coupon/${id}`, rest);
    }

    deleteCoupons(payload) {
        const { id, couponIds } = payload;
        return this.delete(`coupon/${id}`, { couponIds: couponIds });
    }

    exportCouponsList(id) {
        return this.get(`coupon/files-export/${id}`, { page: -1 }, { responseType: 'blob' });
    }

    // #region CMS
    getCouponsCMS(payload) {
        return this.get('coupons', payload);
    }

    getCouponDetail(id) {
        return this.get(`coupons/${id}`);
    }

    createCoupon(payload) {
        return this.post('coupons', payload);
    }

    updateCoupon(payload) {
        const { id, ...rest } = payload;
        return this.put(`coupons/${id}`, rest);
    }

    deleteCoupon(id) {
        return this.delete(`coupons/${id}`);
    }
}
